import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 2A23AD1A-C4F1-47B1-B482-05836097CE51
 * name current-dc
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/current-dc.svg
 * tags
 * - Battery 
 */
export const CurrentDcIcon = createSvgIcon(<><path d="M2,9V11H22V9H2M2,13V15H7V13H2M9,13V15H15V13H9M17,13V15H22V13H17Z" /></>, 'CurrentDcIcon');
export default CurrentDcIcon